export default __webpack_public_path__ + "static/media/MoonOutlineIcon.893485cb.svg";